const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const validateBOUsersForm = (data) => {
  const errors = {};
  if (!data.firstName?.trim()) {
    errors.firstName = "First name is required.";
  }
  if (!data.lastName?.trim()) {
    errors.lastName = "Last name is required.";
  }
  if (!data.email?.trim()) {
    errors.email = "Email is required.";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "Email is invalid.";
  }
  if (!data.contactNum?.trim()) {
    errors.contactNum = "Contact number is required.";
  }
  if (!data.role?.trim()) {
    errors.role = "Role is required.";
  }
  return errors;
};
